import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppContext } from '../Lib/contextLib';
import { useDispatch } from 'react-redux';

export const AuthenticatedRoute = () => {
  const { isAuthenticated } = useAppContext();
  const dispatch = useDispatch();

  if (!isAuthenticated && localStorage.getItem('token') === 'false') {
    dispatch({ type: 'CLEAR' });
  }

  return isAuthenticated && localStorage.getItem('token') === 'true' ? (
    <Outlet />
  ) : (
    <Navigate to='/' />
  );
};
